import { NAME_TOKEN } from '@/constants'
import { deleteCookie } from '@/libs/common'

export default {
  getToken() {
    return localStorage.getItem(NAME_TOKEN) || ''
  },
  setToken(token) {
    localStorage.setItem(NAME_TOKEN, token)
  },

  clearToken() {
    localStorage.removeItem(NAME_TOKEN)
  },

  clearLocalStorage() {
    const exceptKeys = [
      'show-warning-modal',
      'show-fee-upgrade',
    ]
    Object.keys(localStorage).forEach(k => {
      if (!exceptKeys.includes(k)) localStorage.removeItem(k)
    })
    deleteCookie('add_fund_data')
  },

  getCookie(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  },
}
